import React from 'react';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MaterialTable from 'material-table';
import { Status, StockOrderStatusEnum } from 'openapi';
import StatusColumn from '../labels/StatusColumn';
import { useTranslation } from 'react-i18next';

interface Props {
    handleClickOpen: () => void,
    handleClose: () => void,
    open: boolean,
    statusList: Status[],
}

const DialogContent = withStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

export default ((props) => {
    const {t} = useTranslation();

    return (
        <Dialog fullWidth={true} maxWidth='md' onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
            <DialogContent dividers>
                <MaterialTable
                    title={t('statusList')}
                    columns={[
                        { title: t('orderNo'), field: 'orderRequestId' },
                        { title: t('createdDate'), field: 'createdDate', type: 'date' },
                        {
                            title: t('status'), field: 'orderStatus', editable: 'never',
                            render: data => <StatusColumn status={data ? data.status : StockOrderStatusEnum.Waiting} />,
                        },
                        { title: t('messageCode'), field: 'messageCode' },
                        { title: t('message'), field: 'message' },
                    ]}
                    data={props.statusList}
                    options={{
                        search: false,
                        sorting: false,
                        filtering: false,
                        paging: false
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={props.handleClose} color="primary">Close</Button>
            </DialogActions>
        </Dialog>
    );
}) as React.FC<Props>